var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgManagerPhone(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.23727 8.76226C6.45727 7.98226 5.86927 7.10892 5.4786 6.22292C5.39593 6.03559 5.4446 5.81626 5.58927 5.67159L6.13527 5.12626C6.5826 4.67892 6.5826 4.04626 6.19193 3.65559L5.40927 2.87292C4.8886 2.35226 4.0446 2.35226 3.52393 2.87292L3.08927 3.30759C2.59527 3.80159 2.38927 4.51426 2.5226 5.22092C2.85193 6.96292 3.86393 8.87026 5.4966 10.5029C7.12927 12.1356 9.0366 13.1476 10.7786 13.4769C11.4853 13.6103 12.1979 13.4043 12.6919 12.9103L13.1259 12.4763C13.6466 11.9556 13.6466 11.1116 13.1259 10.5909L12.3439 9.80892C11.9533 9.41826 11.3199 9.41826 10.9299 9.80892L10.3279 10.4116C10.1833 10.5563 9.96393 10.6049 9.7766 10.5223C8.8906 10.1309 8.01727 9.54226 7.23727 8.76226Z",
    stroke: "#FF5800",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgManagerPhone);
export default __webpack_public_path__ + "static/media/Manager_phone.1d3b141223bef187150b2350060d72c6.svg";
export { ForwardRef as ReactComponent };